import React from 'react'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import AutoComplete from 'material-ui/AutoComplete';
import Snackbar from '@material-ui/core/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'material-ui/DatePicker';
import Checkbox from '@material-ui/core/Checkbox'
import DialogBox from './Dialogbox';
import { getPOnumbers, getProhibitedPONumbers, validatePaymentRequest, validatePaymentRequestWhileCreation } from '../utils/PaymentRequestApiUtils'
import { data } from '../component-data/paymentrequest-data/PaymentRequest'
import { formats } from './fileUploadAllowedFormats';
const constants = require('../config/constants');

const errorText = 'This field is required'
class PaymentRequest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data : {
        ...data,
        mode_of_payment: 'Online Payment',
        po_soft_copy_file: null,
        po_number: null,
        invoice_soft_copy_link: null,
        supporting_document_link: null
      },
      type_of_payments: ['Advance Against PO', 'Final Settlement'],
      type_of_paymentErr: false,
      type_of_paymentErrText: '',
      vendors: [],
      po_numberErr: false,
      po_numberExistErr: false,
      po_numberExistErrText: '',
      po_numberErrText: '',
      tds_liabilities: ['Services/ Salary', 'Contracts'],
      it_section_applicables: ['194C-contract', '194J -Any Professional Service', '194H -Commision', '194A- Interest on Loan', '194I-Rent'],
      value: '',
      expenditure_months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      expenditure_monthErr: false,
      expenditure_monthErrText: '',
      date_of_invoiceErr: false,
      date_of_invoiceErrText: '',
      bill_availabilitys: ['Bill submitted to HQ-Fin', 'Bills couriered to HQ-Fin', 'Bills with Requestor', 'Bills with Ops', 'Soft Copy sent to HQ-Fin'],
      mode_of_payments: ['Cash', 'Happay', 'Corporate Cards (by HDFC)', 'Payment Cards (by HDFC)', 'Utility Cards (by HDFC)', 'Employee Reimbursement', 'Online Payment', 'Cheque/ DD'],
      mode_of_paymentErr: false,
      mode_of_paymentErrText: '',
      narrationErrText: '',
      narrationErr: false,
      invoice_linkErrText: '',
      invoice_linkErr: false,
      invoicePopUp: false,
      invoice_numberErr:false,
      invoiceNumberWarningGiven: false,
      invoice_numberExistErr: false,
      invoice_numberExistErrText: '',
      invoice_numbers: [],
      status: true,
      snackText: '',
      snackOpen: false,
      searchText: '',
      editData: {},
      index: undefined,
      paymentType: '',
      poSoftCopyErrText: '',
      poSoftCopyErr: false,
      poPopUp: false,
      poNumberWarningGiven: false,
      allowedFileSize: 5242880,
      acceptedFormats: ['image/png','image/jpeg', 'application/pdf'],
      po_numbers: [],
      prohibited_po_numbers : [],
      addNewPO: false,
      poButtonText: 'Add New',
      disablePOSelect: false,
      warningEntries: ['0', 'na', 'not applicable', '-']
    }
  }
  componentDidMount(props) {
    if (this.props.data.paymentDetails !== undefined) {
      this.setState({
        data: this.props.data.paymentDetails,
        searchText: this.props.data.paymentDetails.po_number,
        status: this.props.data.status,
        paymentType: this.props.data.paymentType
      })
    }
    getPOnumbers(this.props.data.paymentDetails.vendor_code, this.props.data.paymentType).then((response) => {
      if (response) {
        if (response.status === 'success')
          if(!response.data.length)
            this.setState({ po_numbers: response.data, addNewPO: true, disablePOSelect: true, poButtonText:  'Select Existing' })
          else
            this.setState({ po_numbers: response.data, addNewPO: false, disablePOSelect: false })
      }
    })
    getProhibitedPONumbers(this.props.data.paymentDetails.vendor_code).then((response) => {
      if (response) {
        if (response.status === 'success')
          this.setState({ prohibited_po_numbers: response.data})
      }
    })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data.paymentDetails !== undefined) {
      this.setState({
        data: nextProps.data.paymentDetails, //check whether this is required!
        searchText: ``,
        status: nextProps.data.status,
        prevPath: nextProps.data.paymentDetails.prevPath
      })
    }
  }
  handleChange = (props) => (event, index, value) => {
    if (props === 'bank_acc_number') {
      let myregex = /^[A-Za-z0-9]{0,18}$/
      if (!myregex.test(event.target.value)) {
        this.setState({ snackText: 'Invalid Bank Account number', snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value } })
      }
    }
    else if (props === 'ifsc_code') {
      let myRegxp = /^([a-zA-Z0-9_-]){0,11}$/
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "IFSC length should be 11 characters", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value } })
      }
    }
    else if (props === 'date_of_invoice') {
      this.setState({ 
        data: { 
          ...this.state.data, [props]: index 
        }, 
        [props + 'ErrText']: '', 
        [props + 'Err']: false 
      }, () => {
        this.handleInvoiceNumberValidation();
      });
    }
    else if (props === 'po_number') {
      if(this.state.addNewPO === true) {
        if (this.state.warningEntries.includes(event.target.value.toLowerCase()) || (constants.emptyRegxp.test(event.target.value))) {
          console.log("case insensitive match !");
          this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: true }, () => console.log(" Po error : "+this.state.po_numberErr));
        } 
        else {
          this.setState({
          data: {
            ...this.state.data, [props]: event.target.value
          },
          [props + 'ErrText']: '', [props + 'Err']: false
          })
        }
      }
      else {
        if (this.state.warningEntries.includes(event.toLowerCase())) {
          this.setState({ data: { ...this.state.data, [props]: event }, [props + 'ErrText']: '', [props + 'Err']: false, poNumberWarningGiven: true });
        } 
        else {
          this.setState({
          data: {
            ...this.state.data, [props]: event
          },
          [props + 'ErrText']: '', [props + 'Err']: false
          })
        }
      }
    }
    else if (props === 'narration') {
      if (event.target.value.length > data.max_character_limit) {
        this.setState({ data: { ...this.state.data, [props]: event.target.value.substr(0,data.max_character_limit) }, narrationErrText: `Max. character count is ${data.max_character_limit}`, narrationErr: true })
      } else 
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
    else if (props === 'invoice_number') {
      if (this.state.warningEntries.includes(event.target.value.toLowerCase()) || (constants.emptyRegxp.test(event.target.value))) {
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: true })
      } else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }
    else if (props === 'expenditure_start_date' ||  props === 'expenditure_end_date') {
      if(props === 'expenditure_end_date' && this.state.data.expenditure_start_date !== null && this.state.data.expenditure_start_date > index){
        this.setState({ expenditure_end_dateErrText: 'End date should be greater than start date', expenditure_end_dateErr: true })
        return;
      }

      this.setState({ 
        data: { 
          ...this.state.data, [props]: index 
        }, 
        [props + 'ErrText']: '', 
        [props + 'Err']: false 
      })
    }
    else {
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
  }
  handleEdit(value) {
    this.setState({ editData: this.state.data[value], status: false, index: value })
  }
  handleNext() {
    if (this.state.data.expenditure_month.length === 0) {
      this.setState({ expenditure_monthErrText: errorText, expenditure_monthErr: true })
    }
    if (this.state.data.date_of_invoice === null) {
      this.setState({ date_of_invoiceErrText: errorText, date_of_invoiceErr: true })
    }

    if (this.state.data.mode_of_payment === '') {
      this.setState({ mode_of_paymentErrText: errorText, mode_of_paymentErr: true })
    }

    if (this.state.data.narration === '') {
      this.setState({ narrationErrText: errorText, narrationErr: true })
    }
    
    if(this.state.paymentType === 'Advance Against PO'){
      // check for PO number
      let poNumberError = this.state.po_numberErr;
      if (!this.state.poNumberWarningGiven || poNumberError) {
        if (this.state.data.po_number && this.state.warningEntries.includes(this.state.data.po_number.toLowerCase())) {
          poNumberError = true;
          this.setState({ po_numberErrText: errorText, po_numberErr: poNumberError, poPopUp:true, poNumberWarningGiven: true});
        } 
      }
      if(this.state.data.po_number === null || constants.emptyRegxp.test(this.state.data.po_number) || this.state.data.po_number.toLowerCase() === 'null'){
        poNumberError = true;
        this.setState({ po_numberErrText: errorText, po_numberErr: poNumberError});
      }
      if (this.state.data.vendor_name !== '' && this.state.data.type_of_payment !== '' && this.state.data.expenditure_month.length !== 0
      && this.state.data.mode_of_payment !== '' && this.state.data.date_of_invoice !== null && this.state.data.narration !== '' 
      && !poNumberError  && !this.state.po_numberExistErr) {
        this.props.handleNext(this.state.data)
        }
    }
    else if(this.state.paymentType === 'Final Settlement'){
      if (this.state.data.date_of_invoice === null) {
        this.setState({ date_of_invoiceErrText: errorText, date_of_invoiceErr: true })
      }

      if (this.state.data.date_of_invoice === null) {
        this.setState({ date_of_invoiceErrText: errorText, date_of_invoiceErr: true })
      }
      let invoiceNumberError = this.state.invoice_numberErr;
      if (!this.state.invoiceNumberWarningGiven || invoiceNumberError) {
        if (this.state.warningEntries.includes(this.state.data.invoice_number.toLowerCase())) {
          invoiceNumberError = true;
          this.setState({ invoice_numberErrText: errorText, invoice_numberErr: invoiceNumberError, invoicePopUp:true, invoiceNumberWarningGiven: true});
        } else if (constants.emptyRegxp.test(this.state.data.invoice_number)) {
          invoiceNumberError = true;
          this.setState({ invoice_numberErrText: errorText, invoice_numberErr: invoiceNumberError});
        }
      }

      if (this.state.data.bill_availability === '') {
        this.setState({ bill_availabilityErrText: errorText, bill_availabilityErr: true })
      }
      if (this.state.data.invoice_soft_copy_link === '') {
        this.setState({ invoice_linkErrText: errorText, invoice_linkErr: true })
      }
      if (this.state.data.invoice_soft_copy_link !== '' && typeof this.state.data.invoice_soft_copy_link !== 'undefined' && this.state.data.invoice_soft_copy_link!=null) {
        let urlRegxp = constants.urlRegxp;
        if (!urlRegxp.test(this.state.data.invoice_soft_copy_link)) {
          this.setState({ invoice_linkErrText: 'Drive link is not in the right format (https://drive.google.com/xx or https://www.google.com)', invoice_linkErr: true });
          return false;
        }
      }
      if (this.state.data.vendor_name !== '' && this.state.data.type_of_payment !== ''
      && this.state.data.date_of_invoice !== null && this.state.data.expenditure_month.length !== 0
      && this.state.data.mode_of_payment !== '' && this.state.data.bill_availability !== '' && this.state.data.narration !== '' 
      && this.state.data.invoice_soft_copy_link !== '' && !invoiceNumberError && !this.state.invoice_numberExistErr) {
      this.state.status !== 'edit' ?
        validatePaymentRequest(this.state.data.vendor_code, this.state.data.invoice_number, this.state.data.date_of_invoice)
          .then(response => {
            if (response) {
              if (response.status === 'success') {
                this.props.handleNext(this.state.data)
              }
              else {
                this.setState({ snackText: response.message, snackOpen: true })
              }
            }
          }) : this.props.handleNext(this.state.data)
      }
    }    
  }
  handleClear() {
    this.setState({
      data,
      searchText: '',
      type_of_paymentErr: false,
      type_of_paymentErrText: '',
      po_numberErr: false,
      po_numberErrText: '',
      po_numberExistErr: false,
      po_numberExistErrText: '',
      poPopUp: false,
      poNumberWarningGiven:false,
      value: '',
      expenditure_monthErr: false,
      expenditure_monthErrText: '',
      date_of_invoiceErr: false,
      date_of_invoiceErrText: '',
      mode_of_paymentErr: false,
      mode_of_paymentErrText: '',
      narrationErrText: '',
      narrationErr: false,
      invoice_linkErrText: '',
      invoice_linkErr: false,
      invoicePopUp: false,
      invoiceNumberWarningGiven:false,
      invoice_numberErr: false,
      invoice_numberErrText: '',
      invoice_numberExistErr: false,
      invoice_numberExistErrText:'',
      bill_availabilityErr: false,
      bill_availabilityErrText: '',
      status: true,
      snackText: '',
      snackOpen: false,
    })
    this.props.handleClear()
  }
  handleDetails(value) {

    let data = this.state.data === undefined ? [] : this.state.data
    if (value.status === 'new') {
      data.push(value)
    }
    else {
      data[this.state.index] = value
    }
    this.setState({ status: true, data })
  }
  handleDelete(value) {
    let data = this.state.data.filter((data, index) => index !== value)
    this.setState({ data })
  }
  handleUpdateInput = (searchText) => {
    if(this.state.po_numbers.includes(searchText)){
      this.setState({
        searchText: searchText,
      });
    }
    else{
      this.setState({
        data: { ...this.state.data, po_number: null},
        searchText: '',
      });
    }
  };
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }

  poSoftCopyHandler = (event) => {
    /*check file format*/
    if(this.state.acceptedFormats.indexOf(event.target.files[0].type)!==-1) {
      /*check for file size*/
      if(event.target.files[0].size <= this.state.allowedFileSize) {
        this.setState({ data: { ...this.state.data, po_soft_copy_file: event.target.files[0], invoice_soft_copy_link: event.target.files[0].name }, poSoftCopyErrText: '', poSoftCopyErr: false })
      }
      else {
        this.setState({ poSoftCopyErrText: `Uploaded image exceeds ${this.state.allowedFileSize / 1024 / 1024} MB`, poSoftCopyErr: true });
        return false;
      }
    }
    else {
      this.setState({ poSoftCopyErrText: 'Only png,jpeg,pdf images are allowed for this field', poSoftCopyErr: true });
      return false;
    }
  }

  handleAddNewPO() {
    if(this.state.addNewPO === false){
      this.setState({data: { ...this.state.data, po_number: null }, addNewPO: true, poButtonText:  'Select Existing' })
      if(this.state.data.po_number !== '')
      this.handlePOnumberValidation(); 
    }
    else{
      this.setState({ data: { ...this.state.data, po_number: null }, addNewPO: false, poButtonText: 'Add New', searchText: '', po_numberErr: false, po_numberErrText: '', po_numberExistErr: false })
    }
  }
  handlePOnumberValidation = async() =>{
    let po_number = (this.state.data.po_number !== undefined && this.state.data.po_number !== null)?this.state.data.po_number.trim():'';
    if(!(constants.emptyRegxp.test(po_number))){
      if(this.state.prohibited_po_numbers.indexOf(po_number) < 0 && this.state.po_numbers.indexOf(po_number) < 0 ) {
        this.setState({data: { ...this.state.data, po_number: po_number }, po_numberExistErrText: 'PO Number is valid', po_numberExistErr: false});
      }
      else {
        if(this.state.prohibited_po_numbers.indexOf(po_number) >= 0){
          this.setState({data: { ...this.state.data, po_number: po_number },po_numberExistErrText: 'PO Number already associated with an Invoice number', po_numberExistErr: true});
        }
        else{
          this.setState({data: { ...this.state.data, po_number: po_number },po_numberExistErrText: 'PO Number already in use', po_numberExistErr: true});
        }
      }
    }
  }
  handleInvoiceNumberValidation = async() =>{
    let invoice_number = (this.state.data.invoice_number !== undefined && this.state.data.invoice_number !== null)?this.state.data.invoice_number.trim():'';
    let date_of_invoice = (this.state.data.date_of_invoice !== undefined && this.state.data.date_of_invoice !== null) ? this.state.data.date_of_invoice : null;
    let vendor_code = this.state.data.vendor_code;
    if(!(constants.emptyRegxp.test(invoice_number)) && date_of_invoice) {
      validatePaymentRequestWhileCreation(vendor_code, invoice_number, date_of_invoice)
      .then(response => {
        if (response) {
          if (response.status === 'success') {
            this.setState({data: { ...this.state.data, invoice_number: invoice_number }, invoice_numberExistErrText: 'Invoice Number is valid', invoice_numberExistErr: false});
          }
          else {
            this.setState({data: { ...this.state.data, invoice_number: invoice_number }, invoice_numberExistErrText: 'Invoice Number already in use', invoice_numberExistErr: true});
          }
        }
      })
    }
  }

  // Allow selecting expenditure end date up to 18 months in the future
  maxExpenditureEndDate = () => {
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 18);
    return maxDate;
  }

  render() {
    return (
      <MuiThemeProvider >
        <div>
        {this.state.paymentType === 'Advance Against PO' && 
          <div>
            {this.state.poPopUp && 
              <DialogBox 
                AlertText='The PO number entered seems to be incorrect. Are you sure you want to continue?' 
                handleYes={() => {
                  this.setState({po_numberErrText: '', po_numberErr: false, poPopUp:false})
                }} 
                handleNo={() => {
                  this.setState({po_numberErrText: errorText, po_numberErr: true, poPopUp:false})
                }} 
              />
            }
            <div>
          {this.state.addNewPO === false && 
            <AutoComplete
            hintText="Select a PO Number"
            errorText={this.state.po_numberErrText}
            errorStyle={{ fontSize: '12px', color: 'red' }}
            floatingLabelText='*PO Number'
            searchText={this.state.searchText}
            onUpdateInput={this.handleUpdateInput}
            onNewRequest={this.handleChange('po_number')}
            dataSource={this.state.po_numbers}
            filter={AutoComplete.caseInsensitiveFilter}
            openOnFocus={true}
            onBlur = {()=> this.handlePOnumberValidation()}
            textFieldStyle={{ width: '260px' }}
            listStyle={{ width: '260px', maxHeight: 100, overflow: 'auto'  }}
            underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
            floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
            />}
            {this.state.addNewPO === false && 
            <label style={{ padding: '6px 12px', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
              OR
            </label>}
            {this.state.addNewPO === true && 
              <TextField
            label="*PO Number"
            placeholder=" Enter a new PO number"
            value={this.state.data.po_number}
            onChange={this.handleChange('po_number')}
            style={{ width: '260px' }}
            helperText={this.state.po_numberExistErr?this.state.po_numberExistErrText:this.state.po_numberErrText}
            onBlur = {()=> this.handlePOnumberValidation()}
            error={this.state.po_numberExistErr?this.state.po_numberExistErr:this.state.po_numberErr}
            />}
            {this.state.addNewPO === true &&
            <label style={{ padding: '6px 12px', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
              OR
            </label>}
            <RaisedButton
              label={this.state.poButtonText}
              primary={true}
              onClick={()=>this.handleAddNewPO()}
              style={{marginLeft: '20px'}}
              disabled={this.state.disablePOSelect}
            />
            </div>

            <div style={{ display: "flex", justifyContent: 'flex-start', flexWrap: 'wrap'  }}>
              <TextField
                label="PO Soft Copy Upload"
                value={this.state.data.invoice_soft_copy_link || ''}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.poSoftCopyErrText}
                error={this.state.poSoftCopyErr}
              />
              <label for="file-upload1" className="custom-file-upload" style={{ border: '1px solid #ccc', display: 'inline-block', padding: '6px 12px', cursor: 'pointer', height: '13px', marginTop: '37px', marginLeft: '18px' }}>
                Browse
              </label>
              <input id="file-upload1" defaultValue="" type="file" onClick={(event) => event.target.value = null} onChange={this.poSoftCopyHandler.bind(this)} style={{ display: "none" }} accept={formats} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              <DatePicker
                floatingLabelText='*Expenditure start date'
                hintText='Expenditure start date'
                value={this.state.data.expenditure_start_date}
                onChange={this.handleChange('expenditure_start_date')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={new Date()}
                style={{ width: '250px' }}
                errorText={this.state.expenditure_start_dateErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
              <DatePicker
                floatingLabelText='*Expenditure end date'
                hintText='Expenditure end date'
                value={this.state.data.expenditure_end_date}
                onChange={this.handleChange('expenditure_end_date')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={this.maxExpenditureEndDate()}
                style={{ width: '250px', marginLeft: '20px' }}
                errorText={this.state.expenditure_end_dateErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '10px' }} margin='normal'>
              <InputLabel htmlFor="tds-liability">TDS Liability</InputLabel>
              <Select
                value={this.state.data.tds_liability}
                onChange={this.handleChange('tds_liability')}
                inputProps={{
                  name: 'TDS Liability',
                  id: 'tds-liability',
                }}
                style={{ width: '250px', textAlign: 'left' }}
              >
                {
                  this.state.tds_liabilities.map(tds_liability => {
                    return <MenuItem value={tds_liability}>{tds_liability}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl style={{ marginLeft: '20px', marginTop: '10px' }} margin='normal'>
              <InputLabel htmlFor="it-section-applicable">IT Section applicable</InputLabel>
              <Select
                value={this.state.data.it_section_applicable}
                onChange={this.handleChange('it_section_applicable')}
                inputProps={{
                  name: 'IT Section applicable',
                  id: 'it-section-applicable',
                }}
                style={{ width: '250px', textAlign: 'left' }}
              >
                {
                  this.state.it_section_applicables.map(it_section_applicable => {
                    return <MenuItem value={it_section_applicable}>{it_section_applicable}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl>
            <DatePicker
                floatingLabelText='*Date'
                hintText='Date'
                value={this.state.data.date_of_invoice}
                onChange={this.handleChange('date_of_invoice')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={new Date()}
                style={{ width: '250px' }}
                errorText={this.state.date_of_invoiceErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
              />
            </FormControl>
            <FormControl margin='normal' style = {{marginLeft: 20 + 'px'}}>
              <InputLabel htmlFor="expenditure-of-month">*Expenditure of month</InputLabel>
              <Select
                multiple
                value={this.state.data.expenditure_month}
                onChange={this.handleChange('expenditure_month')}
                inputProps={{
                  name: 'Expenditure for the month',
                  id: 'expenditure-of-month',
                }}
                style={{ width: '250px' }}
                error={this.state.expenditure_monthErr}
                renderValue={selected => selected.join(', ')}
              >
                {
                  this.state.expenditure_months.map(expenditure_month => {
                    return <MenuItem key={expenditure_month} value={expenditure_month}>
                      <Checkbox checked={this.state.data.expenditure_month.indexOf(expenditure_month) > -1} />
                      {expenditure_month}
                    </MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.expenditure_monthErrText}</FormHelperText>
            </FormControl>
          </div>
          <div>
          <FormControl>
            <InputLabel htmlFor="mode-of-payment" >*Mode of Payment</InputLabel>
            <Select
              value={this.state.data.mode_of_payment}
              onChange={this.handleChange('mode_of_payment')}
              inputProps={{
                name: 'Mode of payment',
                id: 'mode-of-payment',
              }}
              style={{ width: '250px' }}
              error={this.state.mode_of_paymentErr}
            >
              {
                this.state.mode_of_payments.map(mode_of_payment => {
                  return <MenuItem value={mode_of_payment}>{mode_of_payment}</MenuItem>
                })
              }
            </Select>
            <FormHelperText style={{ color: 'red' }}>{this.state.mode_of_paymentErrText}</FormHelperText>
          </FormControl>
          </div>
          <TextField
            label="*Narration"
            placeholder=" Enter Narration"
            value={this.state.data.narration}
            onChange={this.handleChange('narration')}
            style={{ width: '520px' }}
            helperText={this.state.narrationErrText}
            error={this.state.narrationErr}
            
          />
        </div>
        }
          {this.state.paymentType === 'Final Settlement' && 
          <div>
            {this.state.invoicePopUp && 
              <DialogBox 
                AlertText='The invoice number entered seems to be incorrect. Are you sure you want to continue?' 
                handleYes={() => {
                  this.setState({ invoice_numberErrText: '', invoice_numberErr: false, invoicePopUp:false})
                }} 
                handleNo={() => {
                  this.setState({invoice_numberErrText: errorText, invoice_numberErr: true, invoicePopUp:false})
                }} 
              />
            }
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              <TextField
                label="*Invoice Number"
                placeholder=" Enter Invoice Number"
                value={this.state.data.invoice_number}
                onChange={this.handleChange('invoice_number')}
                onBlur = {()=> this.handleInvoiceNumberValidation()}
                margin='normal'
                style={{ width: '250px' }}
                helperText={this.state.invoice_numberExistErr?this.state.invoice_numberExistErrText:this.state.invoice_numberErrText}
                error={this.state.invoice_numberExistErr?this.state.invoice_numberExistErr:this.state.invoice_numberErr}
                errorText={this.state.invoice_numberExistErr?this.state.invoice_numberExistErrText:this.state.invoice_numberErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
              <DatePicker
                floatingLabelText='*Date of Invoice'
                hintText='Date of Invoice'
                value={this.state.data.date_of_invoice}
                onChange={this.handleChange('date_of_invoice')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={new Date()}
                style={{ width: '250px', marginLeft: '20px' }}
                errorText={this.state.date_of_invoiceErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              <DatePicker
                floatingLabelText='*Expenditure start date'
                hintText='Expenditure start date'
                value={this.state.data.expenditure_start_date}
                onChange={this.handleChange('expenditure_start_date')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={new Date()}
                style={{ width: '250px' }}
                errorText={this.state.expenditure_start_dateErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
              <DatePicker
                floatingLabelText='*Expenditure end date'
                hintText='Expenditure end date'
                value={this.state.data.expenditure_end_date}
                onChange={this.handleChange('expenditure_end_date')}
                floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
                maxDate={this.maxExpenditureEndDate()}
                style={{ width: '250px', marginLeft: '20px' }}
                errorText={this.state.expenditure_end_dateErrText}
                errorStyle={{ fontSize: '12px', color: 'red' }}
                disabled={this.state.status==='edit'}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '10px' }} margin='normal'>
              <InputLabel htmlFor="tds-liability">TDS Liability</InputLabel>
              <Select
                value={this.state.data.tds_liability}
                onChange={this.handleChange('tds_liability')}
                inputProps={{
                  name: 'TDS Liability',
                  id: 'tds-liability',
                }}
                style={{ width: '250px', textAlign: 'left' }}
              >
                {
                  this.state.tds_liabilities.map(tds_liability => {
                    return <MenuItem value={tds_liability}>{tds_liability}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl style={{ marginLeft: '20px', marginTop: '10px' }} margin='normal'>
              <InputLabel htmlFor="it-section-applicable">IT Section applicable</InputLabel>
              <Select
                value={this.state.data.it_section_applicable}
                onChange={this.handleChange('it_section_applicable')}
                inputProps={{
                  name: 'IT Section applicable',
                  id: 'it-section-applicable',
                }}
                style={{ width: '250px', textAlign: 'left' }}
              >
                {
                  this.state.it_section_applicables.map(it_section_applicable => {
                    return <MenuItem value={it_section_applicable}>{it_section_applicable}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl margin='normal'>
              <InputLabel htmlFor="expenditure-of-month">*Expenditure of month</InputLabel>
              <Select
                multiple
                value={this.state.data.expenditure_month}
                onChange={this.handleChange('expenditure_month')}
                inputProps={{
                  name: 'Expenditure for the month',
                  id: 'expenditure-of-month',
                }}
                style={{ width: '250px' }}
                error={this.state.expenditure_monthErr}
                renderValue={selected => selected.join(', ')}
              >
                {
                  this.state.expenditure_months.map(expenditure_month => {
                    return <MenuItem key={expenditure_month} value={expenditure_month}>
                      <Checkbox checked={this.state.data.expenditure_month.indexOf(expenditure_month) > -1} />
                      {expenditure_month}
                    </MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.expenditure_monthErrText}</FormHelperText>
            </FormControl>
            <FormControl style={{ marginLeft: '20px' }} margin='normal'>
              <InputLabel htmlFor="bill-availability">*Bill Availability</InputLabel>
              <Select
                value={this.state.data.bill_availability}
                onChange={this.handleChange('bill_availability')}
                error={this.state.bill_availabilityErr}
                inputProps={{
                  name: 'Bill Availability',
                  id: 'bill-availability',
                }}
                style={{ width: '250px' }}
              >
                {
                  this.state.bill_availabilitys.map(bill_availability => {
                    return <MenuItem value={bill_availability}>{bill_availability}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.bill_availabilityErrText}</FormHelperText>
            </FormControl>
            </div>
            <div>
          <FormControl>
            <InputLabel htmlFor="mode-of-payment" >*Mode of Payment</InputLabel>
            <Select
              value={this.state.data.mode_of_payment}
              onChange={this.handleChange('mode_of_payment')}
              inputProps={{
                name: 'Mode of payment',
                id: 'mode-of-payment',
              }}
              style={{ width: '250px' }}
              error={this.state.mode_of_paymentErr}
            >
              {
                this.state.mode_of_payments.map(mode_of_payment => {
                  return <MenuItem value={mode_of_payment}>{mode_of_payment}</MenuItem>
                })
              }
            </Select>
            <FormHelperText style={{ color: 'red' }}>{this.state.mode_of_paymentErrText}</FormHelperText>
          </FormControl>
          </div>
          <TextField
            label="*Narration"
            placeholder=" Enter Narration"
            value={this.state.data.narration}
            onChange={this.handleChange('narration')}
            style={{ width: '520px' }}
            helperText={this.state.narrationErrText}
            error={this.state.narrationErr}

          />
          <br/>
          <TextField
            label="*Drive Link for soft copy of invoice"
            value={this.state.data.invoice_soft_copy_link || ''}
            //margin='normal'
            onChange={this.handleChange('invoice_soft_copy_link')}
            style={{ width: '520px' }}
            helperText={this.state.invoice_linkErrText}
            error={this.state.invoice_linkErr}
          />
          {/* Show clickable link if invoice_soft_copy_link is a full URL */}
          {this.state.data.invoice_soft_copy_link && this.state.data.invoice_soft_copy_link.startsWith('http') && (
            <div style={{ marginTop: '4px' }}>
              <a href={this.state.data.invoice_soft_copy_link} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#1976d2' }}>
                View Invoice ↗
              </a>
            </div>
          )}
          <br/>
          {/* supporting_document_link: show as read-only links if it's a JSON array (new-zaps), else editable text field */}
          {(() => {
            const sdLink = this.state.data.supporting_document_link;
            try {
              const docs = JSON.parse(sdLink);
              if (Array.isArray(docs) && docs.length > 0) {
                return (
                  <div style={{ marginTop: '8px' }}>
                    <div style={{ fontSize: '12px', color: 'rgba(0,0,0,0.54)', marginBottom: '6px' }}>Supporting Documents (from bill submission)</div>
                    {docs.map((link, i) => (
                      <div key={i} style={{ marginBottom: '4px' }}>
                        <a href={link} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#1976d2' }}>
                          View Attachment {i + 1} ↗
                        </a>
                      </div>
                    ))}
                  </div>
                );
              }
            } catch (e) {}
            // Plain URL or empty — show regular editable text field
            return (
              <TextField
                label="*Drive Link for supporting document"
                value={sdLink || ''}
                onChange={this.handleChange('supporting_document_link')}
                style={{ width: '520px' }}
                helperText={this.state.supporting_document_linkErrText}
                error={this.state.supporting_document_linkErr}
              />
            );
          })()}
          <br/>
          <AutoComplete
            hintText="PO Number"
            floatingLabelText='PO Number'
            searchText={this.state.searchText}
            onUpdateInput={this.handleUpdateInput}
            onNewRequest={this.handleChange('po_number')}
            dataSource={this.state.po_numbers}
            filter={AutoComplete.caseInsensitiveFilter}
            openOnFocus={true}
            textFieldStyle={{ width: '520px' }}
            listStyle={{ width: '520px', maxHeight: 100, overflow: 'auto' }}
            underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
            floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
            />
          </div>
        }
          <div className="zaps-form-actions">

            <RaisedButton
              label="Clear"
              primary={true}
              onClick={this.handleClear.bind(this)}
              buttonStyle={{ backgroundColor: 'red' }}
            />
            <RaisedButton style={{ marginLeft: '20px' }} label={`Next`} primary={true} onClick={this.handleNext.bind(this)} />
          </div>
        </div>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </MuiThemeProvider>
    )
  }
}

export default PaymentRequest


// WEBPACK FOOTER //
// ./src/components/PaymentRequest.js